<div class="popup-container">
  <div class="popup">
    <div div class="margin-left">
      <p>
        {{'Error.SessionExpired'}}
      </p>
    </div>
  </div>
</div>